import { RootState } from "../store";

export const selectBurgerConstructorList = (state: RootState) => state.burgerConstructor;
